"use strict";

exports.__esModule = true;
exports.CreateDeviceScreenPlantTwin = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _DeviceEditorPlantTwin = require("../DeviceEditorPlantTwin");
var _DeviceDataItemsContext = require("../DeviceDataItemsContext");
var _DeviceCollection = require("../DeviceCollection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Screen which allows users to create a new device
 */
var CreateDeviceScreenPlantTwin = exports.CreateDeviceScreenPlantTwin = function CreateDeviceScreenPlantTwin() {
  var deviceCollection = _react["default"].useContext(_DeviceCollection.DeviceCollectionContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var device = {
    uuid: "",
    name: "",
    enabled: true,
    tags: [],
    allowProducing: true,
    hasRealtimeData: false,
    deviceType: "Station",
    currentCycleClassify: "FROMNOW",
    performanceParameters: {
      realtimeDataItems: [],
      historicalDataItems: []
    }
  };
  function handleSubmit(device) {
    deviceCollection.create(device);
  }
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CreateDeviceScreenPlantTwin.title", "Create Device")
  }, /*#__PURE__*/_react["default"].createElement(_DeviceDataItemsContext.DeviceDataItemsContext.Provider, {
    value: []
  }, /*#__PURE__*/_react["default"].createElement(_DeviceEditorPlantTwin.DeviceEditorPlantTwin, {
    device: device,
    onSubmit: handleSubmit,
    onCancelScreenName: "DeviceListPlantTwin"
  })));
};